import isEmpty from '../isEmpty'
import buildQuery from '../buildQuery'
import fromPairs from 'lodash/fromPairs'

const operators = {
  '=': '$eq',
  '!=': '$ne',
  empty: 'empty',
  '!empty': '!empty'
}

const buildQueryRule = ({ path, operator, value, schema }, options = {}) => {
  // If there are a mini set of rules passed in as the value, check that they are
  // not empty
  if (Array.isArray(value)) {
    if (isEmpty({ where: value })) {
      throw new Error(`Invalid rules provided for ${path}`)
    }
    // If value is an array then it's going to be a list of rules and I just need to transform those
    const schemas = fromPairs(
      Object.entries(schema?.schemas || {}).map(([path, schema]) => {
        // For now this will only support array of objects one level deep but this is a good start toward a recursive algorithm for this
        schema = {
          ...schema,
          path,
          key: path
        }

        return [path, schema]
      })
    )
    value = buildQuery(
      { where: value },
      {
        ...options,
        transformRule: undefined, // Prevents buildQueryRule from being called twice
        rootPathIsContact: true, // Prevent contact. from being added to any of these since it's going to be within $elemMatch
        schemas
      }
    )
    // value = transformFilter(
    //   { where: value },
    //   {
    //     ...options,
    //     schemas: schema.schemas,
    //     transformRules: (rules, _options) => {
    //       rules = buildQueryRules(rules, _options)
    //       return rules
    //     },
    //     transformRule: (rule, _options) => {
    //       if (typeof options.transformRule === 'function') {
    //         rule = options.transformRule(rule)
    //       }
    //       return buildQueryRule2(rule, _options)
    //     }
    //   }
    // ).where
  } else if (typeof value === 'object') {
    // Assume the object passed in will just be a DB query object and compare as provided
  } else {
    throw new Error(`Invalid parameter provided for ${path}`)
  }
  if (operator === '=') {
    return { [path]: { $elemMatch: value } }
  } else if (operator === '!=') {
    return { [path]: { $not: { $elemMatch: value } } }
  }
}

export default {
  buildQueryRule,
  operators
}

export {
  buildQueryRule,
  operators
}
